import { reorderFavorites } from '@griply/utils';
import { useCallback } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { ID } from 'shared/types/id';

import { useUpdateUserSettings } from './use-update-user-settings';

export const useReorderFavorites = () => {
  const user = useUser();
  const updateUserSettings = useUpdateUserSettings();

  return useCallback(
    (ids: ID[]) => {
      updateUserSettings({
        favorites: reorderFavorites(user?.settings?.favorites ?? [], ids),
      });
    },
    [updateUserSettings, user?.settings?.favorites],
  );
};
